"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormikAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Component that takes Formik specific fields plus options and passes to the
 * render prop function the adapted props for the form-agnostic Component.
 *
 * @param {Object} props
 * @param {Object} props.field - the formik field object
 * @param {Object} props.form - the formik form object
 * @param {Function} props.render - the function to call to render the component being adapted
 * @param {Object} [props.options] - an optional object containing additional functions/attributes.  Possible values:
 *      {Function} [handleFocus] - callback to be added to onFocus
 *      {Function} [handleBlur] - callback to be added to onBlur
 *      {Function} [format] - when supplied, value will be modified with result
 *      {Object} [atts] - attributes to pass through to the underlying element
 */
// eslint-disable-next-line complexity
var FormikAdapter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormikAdapter, _React$Component);

  function FormikAdapter(props) {
    var _this;

    _classCallCheck(this, FormikAdapter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormikAdapter).call(this, props));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FormikAdapter, [{
    key: "handleFocus",
    value: function handleFocus() {
      var handleFocus = this.props.options.handleFocus;

      if (handleFocus && typeof handleFocus === 'function') {
        // field doesn't have its own onFocus, so just call the callback
        handleFocus();
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(eventOrValue) {
      var _this$props = this.props,
          field = _this$props.field,
          handleBlur = _this$props.options.handleBlur;

      if (handleBlur && typeof handleBlur === 'function') {
        handleBlur();
      }

      field.onBlur.call(field, eventOrValue);
    }
  }, {
    key: "handleChange",
    value: function handleChange(eventOrValue) {
      var _this$props2 = this.props,
          field = _this$props2.field,
          form = _this$props2.form,
          format = _this$props2.options.format;
      var formatter = format && typeof format === 'function' ? format : function (value) {
        return value;
      }; // just pass through if no format function provided

      if (_typeof(eventOrValue) === 'object' && eventOrValue.target) {
        var formattedEvent = eventOrValue;
        formattedEvent.target.value = formatter(formattedEvent.target.value);
        form.handleChange.call(form, formattedEvent);
      } else {
        // Formik expects either Event object or a string so insure this results in a string
        var formattedValue = formatter(eventOrValue).toString();
        form.setFieldValue(field.name, formattedValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          field = _this$props3.field,
          form = _this$props3.form,
          render = _this$props3.render,
          atts = _this$props3.options.atts;
      var fieldName = field.name;
      var isTouched = form.touched[fieldName];
      var isInvalid = !!form.errors[fieldName];
      var errorMessage = form.errors[fieldName] || null; // `form.status` is not always defined, nor is `warnings`

      var warningMessage = form.status && form.status.warnings && form.status.warnings[fieldName] || null;

      var fieldAttributes = _objectSpread({}, atts, field, {
        // add functions overriding the field functions
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleChange
      });

      return render({
        fieldName: fieldName,
        value: field.value,
        atts: fieldAttributes,
        isInvalid: isInvalid,
        isValid: !isInvalid,
        isTouched: isTouched,
        warningMessage: warningMessage,
        errorMessage: errorMessage
      });
    }
  }]);

  return FormikAdapter;
}(_react.default.Component);

exports.FormikAdapter = FormikAdapter;
FormikAdapter.defaultProps = {
  options: {}
};
FormikAdapter.propTypes = {
  field: _propTypes.default.object.isRequired,
  form: _propTypes.default.object.isRequired,
  options: _propTypes.default.shape({
    handleFocus: _propTypes.default.func,
    handleBlur: _propTypes.default.func,
    format: _propTypes.default.func,
    atts: _propTypes.default.object
  }),
  render: _propTypes.default.func.isRequired
};